// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__QgzFO","modal":"style_modal__gYb+E","validationIcon":"style_validationIcon__O-n0Y","text":"style_text__50H60"};